export default "__VITE_ASSET__Ckq6BN9P__"